import { useGame } from "@/contexts/GameContext";
import { AlertTriangle, Check } from "lucide-react";
import { motion } from "framer-motion";
import { nsfwOptions } from "@/lib/constants";
import { Button } from "../ui/button";
import { cn } from "@/lib/utils";

export default function NSFWStep() {
  const { state, dispatch } = useGame();

  const setNSFWMode = (enabled) => {
    dispatch({ type: "UPDATE_SETTINGS", payload: { nsfwEnabled: enabled } });
  };

  return (
    <div className="space-y-4">
      <div className="grid gap-4">
        {nsfwOptions.map((option) => {
          const Icon = option.icon;
          const isSelected = state.settings.nsfwEnabled === option.id;

          return (
            <Button
              key={option.id.toString()}
              onClick={() => setNSFWMode(option.id)}
              size="lg"
              variant="outline"
              className={cn(
                "whitespace-normal relative bg-card/60 backdrop-blur-sm h-auto p-6 rounded-xl outline transition-all duration-200 flex flex-col items-center justify-between gap-2",
                isSelected ? "outline-primary/50" : "outline-none"
              )}
            >
              <Icon className="size-7" />
              <div className="font-bold text-lg">{option.name}</div>
              <div className="text-sm">{option.description}</div>

              {/* Wskaźnik zaznaczenia */}
              {isSelected && (
                <motion.div
                  initial={{ scale: 0.5, opacity: 0 }}
                  animate={{ scale: 1, opacity: 1 }}
                  className="absolute z-10 top-2 right-2 w-5 h-5 bg-primary rounded-full flex items-center justify-center"
                >
                  <Check className="w-3 h-3 text-white" />
                </motion.div>
              )}
            </Button>
          );
        })}
      </div>

      {/* Ostrzeżenie - kompaktowe */}
      {state.settings.nsfwEnabled && (
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3, delay: 0.1 }}
          className="bg-red-900/40 border border-red-500/50 rounded-xl p-4"
        >
          <div className="flex items-start gap-2">
            <AlertTriangle className="w-6 h-6 text-red-300 mt-0.5 flex-shrink-0" />
            <div className="text-xs">
              <strong className="font-semibold block mb-1 text-red-100">
                Uwaga: Tryb 18+ Aktywny!
              </strong>
              Treści dla dorosłych mogą zawierać pytania i wyzwania o
              charakterze erotycznym, wulgarnym lub kontrowersyjnym. Grajcie
              odpowiedzialnie i upewnijcie się, że wszyscy gracze są pełnoletni
              oraz wyrażają zgodę na udział w tego typu rozgrywce.
            </div>
          </div>
        </motion.div>
      )}
    </div>
  );
}
